import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import ExploreSection from "../components/ExploreSection";
import StatsSection from "../components/StatsSection";
import TechnologySection from "../components/TechnologySection";
import VideoSection from "../components/VideoSection";
import GallerySection from "../components/GallerySection";
import InstagramSection from "../components/InstagramSection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="App bg-[#0a0a0a] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <ExploreSection />
      <StatsSection />
      <TechnologySection />
      <VideoSection />
      <GallerySection />
      <InstagramSection />
      <CTASection />
      <Footer />
    </div>
  );
}
